export const version = {
    major: 1,
    minor: 1,
    patch: 227
}
